import React from 'react';
import { PageHero } from '../components/PageHero';
import { TrustStrip } from '../components/TrustStrip';
import { WhyChooseUs } from '../components/WhyChooseUs';
import { FinalCta } from '../components/FinalCta';
import { aboutCopy, images } from '../data/site';
export function AboutPage() {
  return <>
      <PageHero crumbs={[{
      label: 'About'
    }]} title={<>
            Quality <span className="text-brand" data-id="element-444" data-mp="328187zomg8r8">&amp; experience</span>
          </>} intro="A local, family-owned Las Vegas business bringing quality, affordable home maintenance and repair to the valley we call home." data-id="element-443" data-mp="2ejrr3b2cs96f" />
      <TrustStrip data-id="element-445" data-mp="2s9v6pj6q94mw" />

      <section className="bg-white py-20 lg:py-28" data-id="element-446" data-mp="2schcpedyzc30">
        <div className="mx-auto grid max-w-7xl gap-12 px-5 lg:grid-cols-2 lg:items-center lg:gap-20 lg:px-8" data-id="element-447" data-mp="2x86iw0khvr8a">
          <img src={images.team} alt="The Home Repair MD team in front of their work van in Las Vegas" className="aspect-[4/5] w-full rounded-2xl object-cover" data-id="element-448" data-mp="1gu6g8hu9lnhc" />
          <div data-id="element-449" data-mp="1uibkyef277n9">
            <h2 className="font-display text-5xl font-extrabold uppercase leading-[0.95] text-ink lg:text-6xl" data-id="element-450" data-mp="1ujw8vl6vbsc5">
              Who we <span className="text-brand" data-id="element-451" data-mp="23igk61a3mzqc">are</span>
            </h2>
            {aboutCopy.story.map(p => <p key={p} className="mt-6 text-lg leading-relaxed text-ink-muted" data-id="element-452" data-mp="1yivktpr0opd3">
                {p}
              </p>)}
          </div>
        </div>
      </section>

      <section className="bg-ink py-20 lg:py-28" data-id="element-453" data-mp="28hkrsnhdkpek">
        <div className="mx-auto grid max-w-7xl gap-10 px-5 lg:grid-cols-[0.7fr_1.3fr] lg:gap-16 lg:px-8" data-id="element-454" data-mp="28grsu8onr46z">
          <h2 className="font-display text-5xl font-extrabold uppercase leading-[0.95] text-white lg:text-6xl" data-id="element-455" data-mp="2m8g4kauzvqnf">
            Our <span className="text-brand" data-id="element-456" data-mp="2i85wmsnn6q5x">philosophy</span>
          </h2>
          <div data-id="element-457" data-mp="2w7x92oyifyht">
            <p className="font-display text-3xl font-semibold leading-snug text-white sm:text-4xl" data-id="element-458" data-mp="2w7njv3lahvd6">
              {aboutCopy.philosophy[0]}
            </p>
            {aboutCopy.philosophy.slice(1).map(p => <p key={p} className="mt-6 text-lg leading-relaxed text-white/75" data-id="element-459" data-mp="1osjsoqqwqt7w">
                {p}
              </p>)}
          </div>
        </div>
      </section>

      <WhyChooseUs data-id="element-460" data-mp="1xtrpt5hoto0e" />
      <FinalCta data-id="element-461" data-mp="1xt87hno4kxlu" />
    </>;
}